module.exports = __webpack_public_path__ + "static/media/Artboard – 2.cc1f927a.svg";